import { upcomingEvents } from '@/mocks/common';
import { Link } from 'react-router-dom';

export default function UpcomingSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            即将开赛
          </h2>
          <p className="text-sm text-foreground-500 mt-2">提前锁定心仪赛事，抢占最佳赔率</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {upcomingEvents.map((event) => (
            <Link
              key={event.id}
              to={`/category/${event.category}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-5 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full mb-3 inline-block">
                {event.league}
              </span>
              <div className="mb-4">
                <p className="text-sm font-semibold text-foreground-900">{event.homeTeam}</p>
                <p className="text-xs text-foreground-400 my-1">VS</p>
                <p className="text-sm font-semibold text-foreground-900">{event.awayTeam}</p>
              </div>
              <div className="text-xs text-foreground-500 mb-3">
                <i className="ri-time-line mr-1"></i>
                {event.startTime}
              </div>
              <div className="flex gap-2">
                {event.drawOdds > 0 ? (
                  <>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">主</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.homeOdds}</span>
                    </div>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">平</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.drawOdds}</span>
                    </div>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">客</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.awayOdds}</span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">主队</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.homeOdds}</span>
                    </div>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">客队</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.awayOdds}</span>
                    </div>
                  </>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}